function JoinPriorityWaitlistBtn({ user, buttonClass, buttonText, id, buttonIcon }) {
  function handleClick() {
    // Optional: do something else here
    console.log('Join button clicked', user);
  }

  return (
    <>
      <button id={id} className={buttonClass} onClick={handleClick}>
        {buttonText} {buttonIcon && <img src={buttonIcon} alt="Join Waitlist icon" />}
      </button>
    </>
  );
}

export default JoinPriorityWaitlistBtn;
